import { directApiInstance } from './httpClient';

/**
 * SAM-1342 — Confirm (2), Check In (4) and Check Out (5) of a residential invitation: `PUT /invitation/{id}` with
 * `{ status_id }`, like the cancel in invitationCancel.ts. It was `PATCH /invitation/{id}`, whose lambda looks the row
 * up by `legacy_id` (only the Vacay integration sets it): 403 where it is NULL (7 Mares) and, where it matches, the
 * status change landed on ANOTHER invitation. PUT looks up by `id` with the same scope, the state rules and the
 * block on expired passes (409 `pass_expired`, explained by the generic toast, see isPassError).
 */
export const setInvitationStatus = async (id: string | number, statusId: number): Promise<void> => {
  await directApiInstance({ url: `/invitation/${id}`, method: 'PUT', data: { status_id: statusId } });
};
